import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { TextField, MenuItem, ListItemText, Checkbox, Button, Tooltip, InputAdornment } from '@mui/material';
import { Icon, SelectMenu, ExpandedTooltip } from '@livable/saas-react-components';
import { ALLOCATION_METHOD } from 'src/constants/utilities';
import { UnitOptsModal } from './../UnitOptInsModal';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './../styles';
export const UnitForm = observer(_ref => {
  var _store$homeDashboardS2, _store$homeDashboardS3;
  let unitIndex = _ref.unitIndex,
    unitTypeProp = _ref.unitTypeProp,
    isLoaded = _ref.isLoaded,
    utilityType = _ref.utilityType,
    isSubmited = _ref.isSubmited,
    requiredSquareFootage = _ref.requiredSquareFootage,
    showPmsUnitId = _ref.showPmsUnitId,
    _startRerender = _ref._startRerender;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    amenitiesTooltipOpen = _useState2[0],
    setAmenitiesTooltipOpen = _useState2[1];
  const requiredInput = (value, id) => {
    if (!value.trim().length || value === 'none') {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.validateValue(unitIndex, id, false);
    } else {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.validateValue(unitIndex, id, true);
    }
  };
  const requiredInputMinValue = (value, id, minValue) => {
    if (value < minValue) {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.validateValue(unitIndex, id, false);
    } else {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.validateValue(unitIndex, id, true);
    }
  };
  const _useState3 = useState(store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].amenities.length ? store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].amenities.map(item => item.inUnitAmenityOptionId) : []),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAmenities = _useState4[0],
    setSelectedAmenities = _useState4[1];
  const handleAmenitiesChange = (event, child) => {
    if (child.props.value) {
      const globalId = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.amenities.find(item => item.optionId === child.props.value).id;
      const globalGroup = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.amenities.filter(item => item.id === globalId);
      const prevValue = event.target.value.filter(item => item !== child.props.value);
      let triggerId = null;
      globalGroup.map(item => {
        if (prevValue.includes(item.optionId)) {
          triggerId = item.optionId;
        }
      });
      const newValue = event.target.value.filter(item => {
        return item !== triggerId;
      });
      setSelectedAmenities(newValue);
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.changeAmenities(unitIndex, newValue);
    }
  };
  const copyAmenitiesToAll = () => {
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units.map((_i, k) => {
      if (k === 0) return;
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.changeAmenities(k, selectedAmenities);
    });
    _startRerender();
  };
  const optInsTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    className: "".concat(store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].disabledOptOutUtilityIds.length > 0 ? classes.warningButton : ''),
    'custom-attribute': '692-new-billing-module'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('Utility opt-outs')), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: t('add_new_property_flow.opt_ins_hint'),
    placement: "top",
    type: "info"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    type: "info",
    state: "info"
  }))));
  const getAmenitiesNames = data => {
    const amenitiesNames = [];
    data.map(item => {
      var _store$homeDashboardS;
      const idx = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.amenities.findIndex(amenity => amenity.optionId === item);
      amenitiesNames.push("".concat((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.amenities[idx]) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.name));
    });
    return amenitiesNames.join(', ');
  };
  useEffect(() => {
    setSelectedAmenities(store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].amenities.length ? store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].amenities.map(item => item.inUnitAmenityOptionId) : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitTypeProp]);
  useEffect(() => {
    setSelectedAmenities(store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].amenities.length ? store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].amenities.map(item => item.inUnitAmenityOptionId) : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.contentRow
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentItem, " input")
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.unit_number'),
    variant: "outlined",
    fullWidth: true,
    type: "text",
    disabled: store.company.companyFeatureStore.readOnlyPropertyUnitSetup,
    value: store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].name,
    onChange: e => {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.changeName(unitIndex, e.target.value);
      requiredInput(e.target.value, 'name');
    },
    error: isSubmited && !store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.unitsValidation[unitIndex].name
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentItem, " input")
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.sq_ft'),
    variant: "outlined",
    type: "text",
    fullWidth: true,
    disabled: store.company.companyFeatureStore.readOnlyPropertyUnitSetup,
    value: store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].square,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.changeSquare(unitIndex, e.target.value);
      requiredInput(e.target.value, 'square');
      if (requiredSquareFootage) requiredInputMinValue(e.target.value, 'square', 1);
    },
    error: isSubmited && !store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.unitsValidation[unitIndex].square
  })), showPmsUnitId && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentItem, " input pms")
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.pms_unit_name'),
    variant: "outlined",
    type: "text",
    fullWidth: true,
    disabled: store.company.companyFeatureStore.readOnlyPropertyUnitSetup,
    value: store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].pmsUnitName,
    onChange: e => store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.changePmsUnitName(unitIndex, e.target.value)
  })), showPmsUnitId && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentItem, " input pms")
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.pms_unit_id'),
    variant: "outlined",
    type: "text",
    fullWidth: true,
    disabled: store.company.companyFeatureStore.readOnlyPropertyUnitSetup,
    value: store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].pmsUnitId,
    onChange: e => store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.changePmsUnitId(unitIndex, e.target.value),
    InputProps: {
      // The unit list has to say mapped from unmapped at a glance, and an empty box on
      // its own reads as "not filled in yet" rather than "deliberately unmapped".
      endAdornment: store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].pmsUnitId.trim() ? /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "check",
        className: classes.mappedMark
      })) : null
    }
  })), ((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.details) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.utilityTemplates) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.findIndex(i => i.allocationMethod === ALLOCATION_METHOD.ByPercentageShare)) !== -1 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentItem, " input")
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Percentage, %'),
    variant: "outlined",
    type: "text",
    fullWidth: true,
    value: ((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.units[unitIndex].unitUtilities.find(i => i.utilityId === utilityType)) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.allocationPercentage) || '',
    onChange: e => {
      const rawValue = e.target.value.replace(',', '.');
      if (rawValue === '') {
        store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.changeUnitUtilities(unitIndex, utilityType, '');
        return;
      }
      if (!/^\d{0,3}(\.\d{0,2})?$/.test(rawValue)) return;
      const numeric = Number(rawValue);
      if (numeric > 100) return;
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.changeUnitUtilities(unitIndex, utilityType, rawValue);
    }
  })), store.addNewProperty.utilitiesSetupV2.selectedUtilities.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentItem, " modal")
  }, /*#__PURE__*/React.createElement(UnitOptsModal, {
    trigger: optInsTrigger,
    unitIndex: unitIndex,
    isNBM: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentItem, " select")
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: t('add_new_property_flow.amenities_field_hint'),
    placement: "top",
    open: amenitiesTooltipOpen
  }, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: () => setAmenitiesTooltipOpen(true),
    onMouseLeave: () => setAmenitiesTooltipOpen(false),
    onClick: () => setAmenitiesTooltipOpen(false)
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "amenities-selector",
    displayEmpty: true,
    value: selectedAmenities,
    onChange: handleAmenitiesChange,
    multiple: true,
    disabled: store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.amenities.length === 0,
    renderValue: selected => {
      if (selected.length === 0) {
        return /*#__PURE__*/React.createElement("span", null, t('general.none'));
      }
      return getAmenitiesNames(selected);
    },
    label: t('add_new_property_flow.amenities'),
    labelId: "amenities-label"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true,
    value: ""
  }, t('general.none')), store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.amenities.map(amenity => /*#__PURE__*/React.createElement(MenuItem, {
    key: amenity.optionId,
    value: amenity.optionId,
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selectedAmenities.indexOf(amenity.optionId) > -1
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: "".concat(amenity.name)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.copyToAll, " ").concat(unitIndex !== 0 ? 'hidden' : '')
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => copyAmenitiesToAll(),
    'custom-attribute': '693-1-new-billing-module'
  }, "Copy to all")), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentItem, " remove")
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: 'Delete unit',
    placement: 'top',
    type: "grey"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.unitSetup.removeItem(unitIndex);
    },
    'custom-attribute': '693-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  })))));
});